import { render, staticRenderFns } from "./CertResult.vue?vue&type=template&id=cc4cd800&scoped=true&"
import script from "./CertResult.vue?vue&type=script&lang=js&"
export * from "./CertResult.vue?vue&type=script&lang=js&"
import style0 from "./CertResult.vue?vue&type=style&index=0&id=cc4cd800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4cd800",
  null
  
)

component.options.__file = "CertResult.vue"
export default component.exports